import { IDriverSafetyDataStore } from "../../store/types";

const RANGE = "Range";
const RANK = "Rank";
const EMPTY_STRING = "";
const RISK_FACTOR_RANGES = ["harshAccelerationRange", "harshBrakingRange", "harshCorneringRange", "speedingRange", "tailgatingRange"];
const RISK_FACTOR_RANKS = ["harshAccelerationRank", "harshBrakingRank", "harshCorneringRank", "speedingRank", "tailgatingRank"];
const NA_STRING = "N/A";
const OLD_MODEL_VERSION = 2;

export interface IRiskFactorDetail {
    name: string;
    rank: number;
    range: string;
}

export const shouldDisplayTailgating = (mostRecentInsight: IDriverSafetyDataStore | null): boolean => {
    if (!mostRecentInsight) {
        return false;
    }

    const currentMajorVersion = mostRecentInsight.majorVersion;

    if (currentMajorVersion === undefined || currentMajorVersion === null) {
        return false;
    }

    return currentMajorVersion > OLD_MODEL_VERSION;
};

export const transformRiskFactors = (safetyDriverInsights: IDriverSafetyDataStore[]): IRiskFactorDetail[] => {
    const hasSafetyDriverInsights = safetyDriverInsights && safetyDriverInsights.length > 0;
    const mostRecentInsight = hasSafetyDriverInsights ? safetyDriverInsights[safetyDriverInsights.length - 1] : null;

    const isTailgatingDisplayed = shouldDisplayTailgating(mostRecentInsight);

    if (mostRecentInsight === null) {
        const baseFactors = [
            {
                name: "Acceleration",
                rank: 0,
                range: NA_STRING
            },
            {
                name: "Braking",
                rank: 0,
                range: NA_STRING
            },
            {
                name: "Cornering",
                rank: 0,
                range: NA_STRING
            },
            {
                name: "Speeding",
                rank: 0,
                range: NA_STRING
            }
        ];

        if (isTailgatingDisplayed) {
            baseFactors.push({
                name: "Tailgating",
                rank: 0,
                range: NA_STRING
            });
        }

        return baseFactors;
    } else {
        const allKeys = Object.keys(mostRecentInsight)
            .filter(key => isTailgatingDisplayed || !key.includes("tailgating"));

        const numericalFactors = allKeys
            .filter(key => RISK_FACTOR_RANKS.indexOf(key) > -1)
            .reduce(
                (acc, key) => {
                    acc[key.replace(RANK, EMPTY_STRING)] = mostRecentInsight[key] as number;
                    return acc;
                },
                {} as { [key: string]: number }
            );

        const factorRatings = allKeys
            .filter(key => RISK_FACTOR_RANGES.indexOf(key) > -1)
            .reduce(
                (acc, key) => {
                    acc[key.replace(RANGE, EMPTY_STRING)] = mostRecentInsight[key] as string;
                    return acc;
                },
                {} as { [key: string]: string }
            );

        return Object.keys(numericalFactors).map(key => ({
            name: key.charAt(0).toUpperCase() + key.slice(1),
            rank: numericalFactors[key] || 0,
            range: factorRatings[key] || NA_STRING
        }));
    }
};
